export default "__VITE_ASSET__T_Yq1Ec8__"